import Vue from 'vue';
import Veux from 'vuex'

Vue.use(Veux);

export default new Veux.Store({
state: {
cart: [],
location: 0,
userName: '',
password: '',
token: '',
email: '',
city: '',
firstName: '',
lastName: '',
dateOfBirth: '',
sex: '',
homePhone: '',
slotId: '',
userId: 0,
messageBody: "",
otherLocation: 0,
otherUserName: "",
otherSlotId: 0,
otherUserId: 0,
otherWebId: 0,
},

mutations: {

},

});